import {
	handleActions
} from 'redux-actions';
import Immutable from 'immutable';

const PackingItemListState = Immutable.fromJS({
	packingItemList: [],
	activePage: 1,
	itemPerPage: 10,
	totalPage: 1,
	searchWord: ''
});

const packingItemListReducer = handleActions({
	FIND_PACKING_ITEM_LIST: (state, { payload }) => {
		return state.merge({
			packingItemList: payload.data.dataTableData,
			activePage: payload.data.activePage,
			totalPage: payload.data.totalPage,
			itemPerPage: payload.data.itemPerPage,
			searchWord: payload.data.searchWord,
		})
	},
	CHANGE_PACKING_ITEM_ACTIVE_PAGE:(state, { payload }) => {
		return state.merge({
			activePage: payload.activePage,
			itemPerPage: payload.itemPerPage
		})
	},
}, PackingItemListState);

export default packingItemListReducer;


// WEBPACK FOOTER //
// ./src/reducers/packingItemListReducer.js